<div class="step">
    <div class="indicator">
        <div class="circle fulfilled" *ngIf="approvalFlow.forcedStatus === 'approved'">
            <mat-icon svgIcon="check"></mat-icon>
        </div>
        <div class="circle denied" *ngIf="approvalFlow.forcedStatus === 'denied'">
            <mat-icon svgIcon="close"></mat-icon>
        </div>
    </div>
    <div class="text fulfilled">
        <div class="primary">
            <span>{{ forceApprovedDenied() | translate }}</span>
        </div>
        <div class="secondary" data-test-id="force-action-name-and-date">
            {{
                'time-off-v3.byNameOnDate'
                    | translate
                        : { name: approvalFlow.forcedBy.fullName, date: approvalFlow.updatedAt | appDate: 'longDate' }
            }}
        </div>
        <div *ngIf="approvalFlow.forcedStatus === 'denied' && approvalFlow.timeOffComment" class="deny-comment">
            <div class="flex comment">&ldquo;{{ approvalFlow.timeOffComment.comment }}&rdquo;</div>
        </div>
    </div>
</div>
